import React, {Component} from 'react';
import './Home.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import ModernCard from "../../components/ModernCard/ModernCard";
import AnnouncementTicker from "../announcement/AnnouncementTicker";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import MemberBirthDays from "./MemberBirthDays";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import DonutChart from 'react-donut-chart'

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentUser: null,
            hasMembership: null,
            membershipStatus: "",
            birthdays: [],
            memberStats: [],
            anketSayisi:null,
            komisyonSayisi: null,
            isOpen: false,
        };
        this.RightExists = this.RightExists.bind(this);
        this.cancelBirthdays = this.cancelBirthdays.bind(this);
    }

    componentDidMount() {
        this.setState({currentUser: this.props.currentUser});
        // this.props.currentUser.realm !== null && this.getMemberStatsByCity();
        this.props.currentUser.realm !== null && this.getMembersBirthdays();

        this.listChambers();
        this.listSurveys();

    }

    listChambers = () => {
           let params = {
               url: API_BASE_URL+'/oda/fetchOda?page=0&size=1000',
               method: "get",
           };

           request(params)
               .then(response => {
                   this.setState({ komisyonSayisi: response.data.totalElements });
               })
               .catch(error => {
                   showAxiosError(error);
               });
       };

       listSurveys = () => {
        let params = {
            url: API_BASE_URL+'/anket?page=0&size=1000',
            method: "get",
        };

        request(params)
            .then(response => {
                this.setState({ anketSayisi: response.data.totalElements });
            })
            .catch(error => {
                showAxiosError(error);
            });
    };

    RightExists(searchItem) {
        let exists = false;
        const authorities = this.props.authorities;
        for (const authority of authorities) {
            if (authority.authority.includes(searchItem)) {
                exists = true;
            }
        }
        return exists;
    }

    getMembersBirthdays = () => {
        let params = {
            url: API_BASE_URL + "/uye/membersUpComingBirthdays",
            method: "get",
        }
        this.setState({isLoading: true});
        request(params).then(response => {
            let birthdays = response.data;
            this.setState({
                birthdays,
                isLoading: false
            });
        }).catch(error => {
            this.setState({isLoading: false});
            showAxiosError(error);
        })
    }
    getMemberStatsByCity = () => {
        let params = {
            url: API_BASE_URL + "/uye/cityMemberStats",
            method: "get",
        }
        this.setState({isLoading: true});
        request(params).then(response => {
            let memberStats = response.data;
            this.setState({
                memberStats,
                isLoading: false
            });
        }).catch(error => {
            this.setState({isLoading: false});
            showAxiosError(error);
        })
    }

    renderBirthDays() {
        return (
            <div className="page-content">
                <div className="row">
                    {
                        ((this.props.currentUser.realm !== null)) && (this.state.birthdays && this.state.birthdays.length > 0) &&
                        <div className="col-6">
                            <a
                                onClick={() => this.onClickDetail()}>
                                <ModernCard
                                    mode="quickAccess"
                                    name="clock"
                                    fill="fill"
                                    header={false}
                                    footer={false}
                                    targetName={""}
                                    iconHeight="40px"
                                    iconWidth="40px"
                                    info={"Doğum günü yaklaşan üyeleri görmek için tıklayınız"}
                                    unit=" "
                                />
                            </a>
                        </div>
                    }
                </div>
            </div>
        );
    }

    renderStats() {
        return (
            <div className="page-content">
                <div className="row">
                    {
                        ((this.props.currentUser.realm !== null)) &&
                        this.state.memberStats.map(item => {
                            return <div className="col-2">
                                <div>
                                    <div className="modernCard" style={{backgroundColor: "white", textAlign: 'center'}}>
                                        <label style={{
                                            color: "black",
                                            fontFamily: "Arial",
                                            fontWeight: 'bold'
                                        }}>{item.name}</label>
                                        <div style={{
                                            backgroundColor: "white",
                                            textAlign: 'right',
                                            paddingRight: "35px"
                                        }}>
                                            <label style={{
                                                color: "red",
                                                fontFamily: "Arial",
                                                fontWeight: 'bold'
                                            }}>{"Oda İlişiği Kesilmiş Üye: " + item.passiveBranchRelation}</label><br/>
                                            <label style={{
                                                color: "grey",
                                                fontFamily: "Arial",
                                                fontWeight: 'bold'
                                            }}>{"Pasif Üye: " + item.passiveMembership}</label><br/>
                                            <label style={{
                                                color: "rgba(52,182,29,0.93)",
                                                fontFamily: "Arial",
                                                fontWeight: 'bold'
                                            }}>{"Aktif Üye: " + item.active}</label><br/>
                                            <label style={{
                                                color: "cornflowerblue",
                                                fontFamily: "Arial",
                                                fontWeight: 'bold'
                                            }}>{"Toplam Üye: " + item.total}</label>
                                        </div>

                                    </div>
                                    <br/>
                                </div>
                                <br/>
                            </div>
                        })
                    }
                </div>
            </div>
        );
    }

    onClickDetail() {
        this.setState({isOpen: true});
    }

    cancelBirthdays() {
        this.setState({
            isOpen: false,
        })
    }

    render() {
        let uyelikDurumu = "";
        let odaSicilNo = "";
        let kayitliOlunanOda = "";
        let odaKayitTarihi = "";
        let sehirUyeSayisi;
        let odaUyeSayisi;
        let birlikUyeSayisi;
        let isOnayliUye = false;
        odaUyeSayisi = this.props.currentUser.stats.branchMemberCnt ? this.props.currentUser.stats.branchMemberCnt : "0";
        birlikUyeSayisi = this.props.currentUser.stats.chamberMemberCnt ? this.props.currentUser.stats.chamberMemberCnt : "0";
        sehirUyeSayisi = this.props.currentUser.stats.cityMemberCnt ? this.props.currentUser.stats.cityMemberCnt : "0";

        if (this.props.currentUser.member === null) {
            uyelikDurumu = "BAŞVURU YAPMADINIZ!"
            // uyeMesaj = "Portala Hoşgeldiniz. Üye Kaydınızı Oluşturmak İçin Tıklayınız."
        } else {
            odaSicilNo = this.props.currentUser.member.odaSicilNo;
            kayitliOlunanOda = this.props.currentUser.member.city.oda.ad;
            odaKayitTarihi = new Date(this.props.currentUser.member.odaKayitTarihi).toLocaleDateString('tr');

            if (this.props.currentUser.member.basvuruDurumu === "ONAYLANDI") {
                uyelikDurumu = "ONAYLANDI";
                isOnayliUye = true;
                // uyeMesaj = "";
            } else if (this.props.currentUser.member.basvuruDurumu === "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR") {
                uyelikDurumu = "BILGILERIN TAMAMLANMASI BEKLENIYOR";
                // uyeMesaj = "Başvurunuz Eksik Bilgilerin Tamamlanması İçin Tarafınıza İade Edildi. Değişiklik Yapmak İçin Tıklayınız.";
                // openForEdit = true;
            } else if (this.props.currentUser.member.basvuruDurumu === "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR") {
                uyelikDurumu = "BILGILERIN KONTROLU BEKLENIYOR";
                // uyeMesaj = "Üyelik Bilgilerinizin Oda Yetkilisince İncelenmesi Bekleniyor. Başvurunuzda Değişiklik Yapmak İçin Tıklayınız.";
                // openForEdit = true;

            } else if (this.props.currentUser.member.basvuruDurumu === "ODA_YETKILISI_ONAYI_BEKLENIYOR") {
                uyelikDurumu = "YETKILI ONAYI BEKLENIYOR";
                // uyeMesaj = "Üyelik Bilgilerinizin Oda Yetkilisince İncelenmesi Bekleniyor. Başvurunuzda Değişiklik Yapmak İçin Tıklayınız.";
                // openForEdit = true;
            } else if (this.props.currentUser.member.basvuruDurumu === "REDDEDILDI") {
                uyelikDurumu = "REDDEDILDI";
                // uyeMesaj = "Başvurunuz Oda Yetkilisince Reddedildi. Detaylı Bilgi Almak İçin Lütfen Oda Yetkilisiyle İrtibata Geçiniz.";
            }
        }
        if (!this.state.currentUser) {
            return <LoadingIndicator/>;
        }

        return (
            <div className="home-container">
                {(this.props.currentUser.member || this.RightExists("ROLE_RIGHT_ANNOUNCEMENT_READ")) &&
                <div className="row">
                    <div className="col">
                        <ModernCard
                            mode="custom"
                            name="person"
                            fill="fill"
                            header={false}
                            footer={false}
                            targetName="DUYURULAR"
                            iconHeight="50px"
                            iconWidth="50px"
                            unit=" "
                            children={<AnnouncementTicker currentUser={this.props.currentUser}/>}
                        />
                    </div>
                </div>
                }
                <div className="page-content">
                    {
                        (isOnayliUye) &&
                        <div>
                            <div className="row">
                                <div className="col">
                                    <ModernCard
                                        mode="quickAccess"
                                        name="person"
                                        fill="fill"
                                        header={false}
                                        footer={false}
                                        targetName="ÜYELİK DURUMUNUZ"
                                        iconHeight="50px"
                                        iconWidth="50px"
                                        info={uyelikDurumu}
                                        unit=" "
                                        actionParam={"nothing"}
                                        actionMethod={this.doNothing}
                                    />
                                </div>
                                <div className="col">
                                    <ModernCard
                                        mode="quickAccess"
                                        name="membership"
                                        fill="fill"
                                        header={false}
                                        footer={false}
                                        targetName="SİCİL NO"
                                        iconHeight="50px"
                                        iconWidth="50px"
                                        info={odaSicilNo}
                                        unit=" "

                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <ModernCard
                                        mode="quickAccess"
                                        name="corporate"
                                        fill="fill"
                                        header={false}
                                        footer={false}
                                        targetName="KAYITLI OLDUĞUNUZ ODA"
                                        iconHeight="50px"
                                        iconWidth="50px"
                                        info={kayitliOlunanOda}
                                        unit=" "

                                    />
                                </div>
                                <div className="col">
                                    <ModernCard
                                        mode="quickAccess"
                                        name="clock"
                                        fill="fill"
                                        header={false}
                                        footer={false}
                                        targetName="ÜYELİK BAŞLANGIÇ TARİHİ"
                                        iconHeight="50px"
                                        iconWidth="50px"
                                        info={odaKayitTarihi}
                                        unit=" "

                                    />
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row">
                        {
                            (isOnayliUye || ((this.props.currentUser.realm !== null) && !this.RightExists("ROLE_RIGHT_CHAMBER_READ") && !this.RightExists("ROLE_RIGHT_BRANCH_READ"))) &&
                            <div className="col">
                                <ModernCard
                                    mode="quickAccess"
                                    name="people"
                                    fill="fill"
                                    header={false}
                                    footer={false}
                                    targetName="SEHİR ÜYE SAYISI"
                                    iconHeight="50px"
                                    iconWidth="50px"
                                    info={sehirUyeSayisi}
                                    unit=" "
                                />
                            </div>
                        }
                        {
                            (isOnayliUye || (this.props.currentUser.realm !== null)) &&
                            <div className="col">
                                <ModernCard
                                    mode="quickAccess"
                                    name="people"
                                    fill="fill"
                                    header={false}
                                    footer={false}
                                    targetName="KOMİSYON SAYISI"
                                    iconHeight="50px"
                                    iconWidth="50px"
                                     info={this.state.komisyonSayisi !==null ? this.state.komisyonSayisi:"..."}
                                    unit=" "
                                />
                            </div>
                        }
                        {
                            (isOnayliUye || (this.props.currentUser.realm !== null)) &&
                            <div className="col">
                                <ModernCard
                                    mode="quickAccess"
                                    name="people"
                                    fill="fill"
                                    header={false}
                                    footer={false}
                                    targetName="ODA ÜYE SAYISI"
                                    iconHeight="50px"
                                    iconWidth="50px"
                                    info={birlikUyeSayisi}
                                    unit=" "
                                />
                            </div>
                        }
                    </div>
                    <div className="row">
                              {
                            (isOnayliUye || (this.props.currentUser.realm !== null)) &&
                            <div className="col">
                                    <ModernCard
                                        mode="quickAccess"
                                        name="people"
                                        fill="fill"
                                        header={false}
                                        footer={false}
                                        targetName={<Link to="/anketler" style={{ color: 'black' }}>ANKETLER</Link>  }
                                        iconHeight="50px"
                                        iconWidth="50px"
                                        info={this.state.anketSayisi!==null ? this.state.anketSayisi:"..."}
                                        unit=" "
                                    />
                        </div>
                        }
                    </div>
                    <div className="row">
                              {
                            (isOnayliUye || (this.props.currentUser.realm !== null)) &&
                         <div className="col">
                            <DonutChart
                                data={[
                                {
                                    label: 'Aktif Üye Oranı',
                                    value: 85
                                },
                                {
                                    label: 'Pasif Üye Oranı',
                                    value: 15,
                                    // isEmpty: true
                                }
                                    ]}
                            />

                            <DonutChart
                                data={[
                                {
                                    label: 'Toplam Eczane Sayısı',
                                    value: 732
                                },
                                {
                                    label: 'Nöbetçi Eczane Sayısı',
                                    value: 21,
                                    // isEmpty: true
                                    colors: '#009688'
                                }
                                    ]}
                            />
                        </div>
                        }
                    </div>
                    <div className="row">
                              {
                            (isOnayliUye || (this.props.currentUser.realm !== null)) &&
                         <div className="col">
                            <DonutChart
                                data={[
                                {
                                    label: 'Aktif Üye Oranı',
                                    value: 85
                                },
                                {
                                    label: 'Pasif Üye Oranı',
                                    value: 15,
                                    // isEmpty: true
                                }
                                    ]}
                            />

                            <DonutChart
                                data={[
                                {
                                    label: 'Toplam Eczane Sayısı',
                                    value: 732
                                },
                                {
                                    label: 'Nöbetçi Eczane Sayısı',
                                    value: 21,
                                    // isEmpty: true
                                    colors: '#009688'
                                }
                                    ]}
                            />
                        </div>
                        }
                    </div>
                    
                </div>

                {this.props.currentUser.realm !== null && this.renderBirthDays()}
                {this.props.currentUser.realm !== null && this.renderStats()}

                <Modal isOpen={this.state.isOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelBirthdays}>Doğum Günü Yaklaşan Üyeler </ModalHeader>
                    <ModalBody>
                        <MemberBirthDays cancelProcess={this.cancelBirthdays}
                                         currentUser={this.props.currentUser}
                                         birthdays={this.state.birthdays}
                        />
                    </ModalBody>
                </Modal>
            </div>

        );
    }
}


export default Home;


// WEBPACK FOOTER //
// ./src/page/home/Home.js